import { Box, Button, CardMedia, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Step, StepContent, StepLabel, Stepper, TableCell, TableRow, Theme, Typography } from "@mui/material"
import { OrderHistoryTableData, OrderSummaryRes } from "../../../../../redux-store/types/orderManagement"
import dayjs from "../../../../../utils/dayjs"
import { toINR } from "../../../../../utils/utilityFunctions"
import { useDispatch, useSelector } from "react-redux"
import { RootStateType } from "../../../../../redux-store/reducers"
import { ColorMap } from "../../../../investorOverview/types"
import { useState } from "react"
import { DialogCloseIcon } from "../../../../../assets/SvgIcons"
import { getOrderStatusForOrderHistory } from "../../../../../redux-store/actions/orderManagement"
import { applicantStatusMasters, MPOWER_ACCOUNT_TYPE_MASTER } from "../../../../../utils/constant"
import { useHistory } from "react-router"


function OrderSummaryTableBody({ data, handleOnClick }: {
  data: OrderSummaryRes[],
  handleOnClick: (productType: string, header?: string, approvalType?: boolean, paymentType?: boolean, title?: string) => void
}): JSX.Element {

  return (
    <>
      {data.map((obj: OrderSummaryRes) => {
        return (
          <TableRow
            key={obj.product}
            sx={(theme: Theme) => ({
              '& td': {
                paddingTop: "15px",
                paddingBottom: "15px",
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
              },
              '& td:first-of-type': {
                paddingLeft: "0px"
              },
            })}
          >
            <TableCell align="left">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[500],
                })}
              >
                {obj?.product ?? "-"}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[800],
                  textDecoration: 'underline',
                  cursor: 'pointer'
                })}
                onClick={() => handleOnClick(obj?.product, "PLACED", true, false, "Placed")}
              >
                {obj?.ordersPlaced ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[800],
                  textDecoration: 'underline',
                  cursor: 'pointer'
                })}
                onClick={() => handleOnClick(obj?.product, "APPROVED BY CHECKER", true, false, "Approved")}
              >
                {obj?.orderApproved ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[800],
                  textDecoration: 'underline',
                  cursor: 'pointer'
                })}
                onClick={() => handleOnClick(obj?.product, "REJECTED BY CHECKER", true, false, "Rejected")}
              >
                {obj?.orderRejected ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[800],
                  textDecoration: 'underline',
                  cursor: 'pointer'
                })}
                onClick={() => handleOnClick(obj?.product, "PAYMENT SUCCESS", false, true, "Settlement Completed")}
              >
                {obj?.settled ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[800],
                  textDecoration: 'underline',
                  cursor: 'pointer'
                })}
                onClick={() => handleOnClick(obj?.product, "PENDING", false, true, "Settlement Pending")}
              >
                {obj?.settlementPending ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[800],
                  textDecoration: 'underline',
                  cursor: 'pointer'
                })}
                onClick={() => handleOnClick(obj?.product, "PAYMENT NOT REQUIRED", false, true, "Settlement Not Required")}
              >
                {obj?.settlementNotRequired ?? '-'}
              </Typography>
            </TableCell>
          </TableRow>
        )
      })}
    </>

  )
}

function OrderHistoryTableBody({ data, comingFrom }: {
  data: OrderHistoryTableData[],
  comingFrom: string
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [dialogDetails, setDialogDetails] = useState<any>({} as any);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
  const [loadingMap, setLoadingMap] = useState<{ [key: string]: boolean }>({});

  const colorMap: ColorMap = {
    approved: "success.800",
    "approved by checker": "success.800",
    "approved by payment checker": "success.800",
    "payment success": "success.800",
    rejected: "error.500",
    "rejected by checker": "error.500",
    "rejected by payment checker": "error.500",
    pending: 'warning.500',
  }

  const handleOrderDetails = (productOrderTableId: string, productType: string, id: string | number, cartId: string | number, orderStatus: string) => {
    history.push('/order-dashboard-details', {
      productOrderId: productOrderTableId,
      product: productType,
      id,
      cartId,
      orderStatus,
      locationFrom: 'orderHistory'
    });
  }

  const getOrderDetails = async (obj: OrderHistoryTableData) => {
    try {
      setLoadingMap((prev) => ({ ...prev, [obj.id as string]: true }));
      const payload =
      {
        id: obj?.id ?? '',
        product: obj?.productType ?? "",
        productOrderId: obj?.productType?.toLowerCase() === "mf" ? obj?.cartId ?? "" : obj?.productOrderTableId ?? ''
      }

      const orderStatusRes = await (dispatch(getOrderStatusForOrderHistory(payload)) as unknown as Promise<any>)

      // const isMarginMoney = (obj?.productType ?? "")?.toLowerCase() === "margin money";

      // const dataArray: Array<string> = (isMarginMoney ?
      //   ((orderStatusRes?.broker) ?? "") :
      //   ((orderStatusRes?.securityName) ?? "")
      // ).split(",")
      // const transactionTypeArray: Array<string> = (orderStatusRes?.transactionType ?? "").split(",")

      // const combineDataTxnTypeArray = (dataArray ?? []).map((data: string, index: number) => ({
      //   data: (data ?? "").trim(),
      //   transactionType: (transactionTypeArray[index] ?? "").trim()
      // }))

      setDialogDetails({
        orderNumber: obj?.orderNumber ?? "-",
        productTypeCheck: obj?.productType ?? "",
        accountType: obj?.accountType ?? "-",
        orderCreatedAt: orderStatusRes?.orderDate ? dayjs(orderStatusRes?.orderDate).format('DD/MM/YYYY HH:mm:ss') : "-",
        security: orderStatusRes?.securityName ?? "-",
        broker: orderStatusRes?.broker ?? "-",
        transactionType: orderStatusRes?.transactionType ?? "-",
        investmentAmount: toINR({ value: orderStatusRes?.investmentAmount ?? 0, locale, currencyCode }),
        approverId: `${orderStatusRes?.orderApproverName ?? "-"} (${orderStatusRes?.approverId ?? "-"})`,
        checkerStatus: orderStatusRes?.orderStatus ?? "-",
        checkerDate: orderStatusRes?.isOrderApproved === "1"
          ?
          (orderStatusRes?.checkerApprovedAt)
            ?
            dayjs(orderStatusRes?.checkerApprovedAt).format('DD/MM/YYYY HH:mm:ss') : "-"
          :
          (orderStatusRes?.rejectedAt)
            ? dayjs(orderStatusRes?.rejectedAt).format('DD/MM/YYYY HH:mm:ss') : "-",
        checkerComments: orderStatusRes?.checkerRemarks ?? "-",
        paymentCheckerId: `${orderStatusRes?.paymentApproverName ?? "-"} (${orderStatusRes?.paymentCheckerId ?? "-"})`,
        paymentCheckerStatus: orderStatusRes?.paymentStatus ?? "-",
        paymentCheckerDate: orderStatusRes?.isPaymentApproved === "1"
          ?
          (orderStatusRes?.paymentCheckerApprovedAt)
            ?
            dayjs(orderStatusRes?.paymentCheckerApprovedAt).format('DD/MM/YYYY HH:mm:ss') : "-"
          :
          (orderStatusRes?.paymentCheckerRejectedAt)
            ?
            dayjs(orderStatusRes?.paymentCheckerRejectedAt).format('DD/MM/YYYY HH:mm:ss') : "-",
        paymentCheckerComments: orderStatusRes?.paymentCheckerRemarks ?? "-",
        settlementMethodCode: orderStatusRes?.settlementMethodCode ?? "-",
        iciciUTRNo: orderStatusRes?.paymentUTRNumber,
        iciciTxnStatus: orderStatusRes?.iciciTransactionStatus ?? '-',
        securitiesData: orderStatusRes?.securities ?? []
      })

      setDialogOpen(true);

    } catch (e) {
      console.log('Error', e);
    }
    finally {
      setLoadingMap((prev) => ({ ...prev, [obj.id as string]: false }));
    }
  }

  const isCorpus = dialogDetails?.productTypeCheck?.toLowerCase() === "corpus in/out";
  const isMF = dialogDetails?.productTypeCheck?.toLowerCase() === "mf";
  const isFeePayment = dialogDetails?.productTypeCheck?.toLowerCase() === "fee payment";

  const StepperOrderDetails = () => {
    return (
      <Box sx={(theme: Theme) => ({
        padding: '5px 10px',
        border: `1px solid ${theme.palette.grey[800]}B2`,
        borderRadius: '5px'
      })}>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Order Number :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.orderNumber ?? '-'}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Order Created At :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.orderCreatedAt ?? '-'}
          </Typography>
        </Typography>
        <Box
          sx={{
            maxHeight: "600px",
            overflowY: "auto",
            mt: 2,
            display: "flex",
            flexDirection: "column",
            rowGap: "20px"
          }}
        >
          {(dialogDetails?.securitiesData ?? []).map(({
            amount,
            quantity,
            security,
            securityName,
            toSecurity,
            toSecurityName,
            transactionType
          }: {
            amount: string | null,
            quantity: string | null,
            security: string | null,
            securityName: string | null,
            toSecurity: string | null,
            toSecurityName: string | null,
            transactionType: string | null
          }) => {
            return (
              <Box
                key={`${data}-${transactionType}`}
                sx={(theme: Theme) => ({
                  border: `1px solid ${theme.palette.grey[500]}B2`,
                  borderRadius: '5px',
                  p: 2,
                  mr: 1,
                })}
              >
                {isMF ? (
                  <>
                    {["switch", "stp"].includes((`${transactionType ?? ""}`)?.toLowerCase()) ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: 2
                        }}
                      >
                        <Typography
                          variant="body_500"
                          sx={{
                            color: 'text.primary',
                          }}>
                          From Scheme:{' '}
                          <Typography
                            component="span"
                            sx={{
                              ml: 0.5,
                              color: 'text.secondary'
                            }}>
                            {securityName ?? "-"}
                          </Typography>
                        </Typography>

                        <Typography
                          variant="body_500"
                          sx={{
                            color: 'text.primary',
                          }}>
                          To Scheme:{' '}
                          <Typography
                            component="span"
                            sx={{
                              ml: 0.5,
                              color: 'text.secondary'
                            }}>
                            {toSecurityName ?? "-"}
                          </Typography>
                        </Typography>

                        <Typography
                          variant="body_500"
                          sx={{
                            color: 'text.primary',
                          }}>
                          Amount/Units:{' '}
                          <Typography
                            component="span"
                            sx={{
                              ml: 0.5,
                              color: 'text.secondary'
                            }}>
                            {amount ?
                              toINR({
                                value: (amount ?? ""),
                                locale,
                                currencyCode
                              }) :
                              "-"
                            } / {
                              quantity ?
                                quantity :
                                "-"
                            }
                          </Typography>
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: 2
                        }}
                      >
                        <Typography
                          variant="body_500"
                          sx={{
                            color: 'text.primary',
                          }}>
                          Scheme:{' '}
                          <Typography
                            component="span"
                            sx={{
                              ml: 0.5,
                              color: 'text.secondary'
                            }}>
                            {securityName ?? "-"}
                          </Typography>
                        </Typography>
                        <Typography
                          variant="body_500"
                          sx={{
                            color: 'text.primary',
                          }}>
                          Amount/Units:{' '}
                          <Typography
                            component="span"
                            sx={{
                              ml: 0.5,
                              color: 'text.secondary'
                            }}>
                            {amount ?
                              toINR({
                                value: (amount ?? ""),
                                locale,
                                currencyCode
                              }) :
                              "-"
                            } / {
                              quantity ?
                                quantity :
                                "-"
                            }
                          </Typography>
                        </Typography>
                      </Box>
                    )}
                  </>
                ) : (
                  (!(isCorpus || isFeePayment) && (
                    <Box>
                      <Typography
                        variant="body_500"
                        sx={{
                          color: 'text.primary',
                        }}>
                        {`${dialogDetails?.productTypeCheck?.toLowerCase() === 'margin money' ? 'Broker' : 'Security'} :${' '}`}
                        <Typography
                          component="span"
                          sx={{
                            ml: 0.5,
                            color: 'text.secondary'
                          }}>
                          {securityName ?? "-"}
                        </Typography>
                      </Typography>
                    </Box>
                  ))
                )}
                <Box>
                  <Typography
                    variant="body_500"
                    sx={{
                      color: 'text.primary',
                      mt: (isCorpus || isFeePayment) ? 0 : 2,
                    }}>
                    Transaction Type :{' '}
                    <Typography
                      component="span"
                      sx={{
                        ml: 0.5,
                        color: 'text.secondary'
                      }}>
                      {transactionType ?? "-"}
                    </Typography>
                  </Typography>
                </Box>
              </Box>
            )
          })}
        </Box >
        {/* <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Investment Amount :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.investmentAmount ?? '-'}
          </Typography>
        </Typography> */}
      </Box>
    )
  }

  const CheckerDetails = () => {
    return (
      <Box sx={(theme: Theme) => ({
        padding: '5px 10px',
        border: `1px solid ${theme.palette.grey[800]}B2`,
        borderRadius: '5px'
      })}>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Name :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.approverId ?? '-'}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Status :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.checkerStatus ?? '-'}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Date :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.checkerDate ?? '-'}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Comments :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.checkerComments ?? "-"}
          </Typography>
        </Typography>
      </Box>
    )
  }

  const PaymentCheckerDetails = () => {
    return (
      <Box sx={(theme: Theme) => ({
        padding: '5px 10px',
        border: `1px solid ${theme.palette.grey[800]}B2`,
        borderRadius: '5px'
      })}>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Name :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.paymentCheckerId ?? '-'}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Status :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.paymentCheckerStatus}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Date :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.paymentCheckerDate}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Comments :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.paymentCheckerComments}
          </Typography>
        </Typography>
      </Box>
    )
  }

  const ICICIInstructions = () => {
    return (
      <Box sx={(theme: Theme) => ({
        padding: '5px 10px',
        border: `1px solid ${theme.palette.grey[800]}B2`,
        borderRadius: '5px'
      })}>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          UTRN No :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.iciciUTRNo}
          </Typography>
        </Typography>
        <Typography
          variant="body_500"
          sx={{
            color: 'text.primary',
            mt: 2,
          }}>
          Status :{' '}
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              color: 'text.secondary'
            }}>
            {dialogDetails?.iciciTxnStatus}
          </Typography>
        </Typography>
      </Box>
    )
  }

  const showPaymentBox = dialogDetails?.iciciUTRNo;
  const nonPOA = dialogDetails?.accountType?.toLowerCase() !== 'poa';

  const stepperData = nonPOA ?
    [
      {
        label: 'Order Details',
        description: <StepperOrderDetails />
      },
      {
        label: 'Checker Details',
        description: <CheckerDetails />
      }
    ] :
    [
      {
        label: 'Order Details',
        description: <StepperOrderDetails />
      },
      {
        label: 'Checker Details',
        description: <CheckerDetails />
      },
      {
        label: 'Payment Checker Details',
        description: <PaymentCheckerDetails />
      },
      ...(showPaymentBox ? [{ label: 'ICICI Transaction Details', description: <ICICIInstructions /> }] : [])
    ]


  return (
    <>
      {data.map((obj: OrderHistoryTableData) => {
        return (
          <TableRow
            key={`${obj?.clientName}-${obj?.id}`}
            sx={(theme: Theme) => ({
              '& td': {
                paddingTop: "15px",
                paddingBottom: "15px",
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
              },
              '& td:first-of-type': {
                paddingLeft: "0px"
              },
            })}
          >
            <TableCell align="left">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.primary[500],
                })}
              >
                {obj?.clientName ?? "-"}
              </Typography>
            </TableCell>
            <TableCell align="left">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                })}
              >
                {obj?.clientCode ?? "-"}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                })}
              >
                {MPOWER_ACCOUNT_TYPE_MASTER[obj?.accountType ?? ''] ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                })}
              >
                {
                  obj?.investorType ?
                    applicantStatusMasters?.[obj.investorType] ?? obj.investorType
                    : "-"
                }
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                  textTransform: "capitalize"
                })}
              >
                {obj?.modeOfHolding ?? "-"}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                })}
              >
                {obj?.productType ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                })}
              >
                {obj?.orderNumber ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                })}
              >
                {dayjs(obj?.orderDate ?? '-').format('DD/MM/YYYY')}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                  whiteSpace: "nowrap",
                })}
              >
                {toINR({ value: obj?.orderAmount ?? 0, locale, currencyCode })}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: theme.palette.text.primary,
                })}
              >
                {obj?.transactionType ? obj?.productType?.toLowerCase() === 'mf' ? 'MF' : obj?.transactionType ?? '-' : '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: colorMap[obj?.approvalStatus?.toLowerCase()] ? colorMap[obj?.approvalStatus?.toLowerCase()] : theme.palette.text.primary,
                  cursor: comingFrom === 'orderHistory' ? 'pointer' : 'default'
                })}
                onClick={comingFrom === 'orderHistory' ? () => handleOrderDetails(obj?.productOrderTableId ? `${obj?.productOrderTableId}` : '', obj?.productType ?? '', obj?.id ?? '', obj?.cartId ?? '', obj?.approvalStatus ?? '') : () => { '' }}
              >
                {obj?.approvalStatus ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: "20px",
                  letterSpacing: "0.02px",
                  color: colorMap[obj?.paymentStatus?.toLowerCase()] ? colorMap[obj?.paymentStatus?.toLowerCase()] : theme.palette.text.primary,
                  cursor: comingFrom === 'orderHistory' ? 'pointer' : 'default'
                })}
                onClick={comingFrom === 'orderHistory' ? () => handleOrderDetails(obj?.productOrderTableId ? `${obj?.productOrderTableId}` : '', obj?.productType ?? '', obj?.id ?? '', obj?.cartId ?? '', obj?.approvalStatus ?? '') : () => { '' }}
              >
                {obj?.paymentStatus ?? '-'}
              </Typography>
            </TableCell>
            {comingFrom === 'orderHistory' && (
              <TableCell align="center">
                {loadingMap[obj.id as string] ? (
                  <CircularProgress size={20} />
                ) : (
                  <IconButton
                    onClick={() => getOrderDetails(obj)}
                  >
                    <CardMedia
                      component="img"
                      src="/images/comment.svg"
                      alt="comment"
                      sx={{ width: '20px' }}
                    />
                  </IconButton>
                )
                }
              </TableCell>
            )}
          </TableRow>
        )
      })}
      <Dialog
        onClose={() => setDialogOpen(false)}
        open={dialogOpen}
        sx={{
          ".MuiPaper-root": {
            width: { xs: "70%", sm: "70%", lg: "80%" },
            overflow: "auto"
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h2">Order Status</Typography>
          <IconButton onClick={() => setDialogOpen(false)} aria-label="close-order-status-dialog">
            <DialogCloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ padding: "0 30px", mt: 2 }}>
            {/* Stepper with no active step */}
            <Stepper activeStep={-1} orientation="vertical">
              {stepperData.map((step, index) => (
                <Step key={index} expanded={true}>
                  <StepLabel
                    StepIconProps={{
                      sx: (theme: Theme) => ({
                        color: theme.palette.grey[500]
                      })
                    }}
                  >
                    <Typography variant="h2" color={'text.primary'}>{step.label}</Typography>
                  </StepLabel>
                  <StepContent>
                    <Typography variant="body_500">
                      {step.description}
                    </Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>

          <Button
            variant="contained"
            sx={{ ml: "32%", lineHeight: 1.1, width: "30%", mt: 3, mb: 4 }}
            onClick={() => setDialogOpen(false)}
          >
            OK
          </Button>
        </DialogContent>
      </Dialog>
    </>

  )
}

export { OrderSummaryTableBody, OrderHistoryTableBody }
